export enum Weapon {
  sword = "miecz",
  axe = "topor",
  dagger = "sztylet",
  hammer = "mlot",
  club = "maczuga",
  poleArms = "drzewiec",
  unknown = "nieznana",
}
